import $ from 'jquery';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { editorConfig } from '~config';
import {
  onAddImageToCanvas,
  onBackgroundChange,
  onFilterTextValueChange,
  onFilterValueChange,
} from './image';
import {
  onTextSpacingValueChangeV,
  onTextSpacingValueChangeH,
  onTextOpacityValueChange,
} from '~core/text';
import {
  getUrlExtension,
  handleDeleteAttachment,
  handleDownloadAttachment,
  handleSetPhotoProfile,
  enableTooltips,
  EdgeResizer,
} from '~src/utils';
import {
  returnToMenu,
  triggerStateChangedRequest,
  toggleObjectEraser,
} from '~core';
import { modifyState, getState, toggleState, unsetState } from '~src/state';
import { getAxiosClient, deleteImages, deleteBackgrounds } from './api';
import {
  addPage,
  handleChangePageBtn,
  handleDeletePageBtn,
} from '~src/multipages';
import {
  displayBackgroundManagerMultiTag,
  displayImageManagerMultiTag,
  handleSidebarBackgrounds,
  handleSidebarImages,
  handleSidebarLogos,
  handleTabAnnunciFunebri,
  handleTabTemplates,
  handleTabImagesAI,
  handleBuyAiCredits,
  listenForImagesTagSearchEmpty,
  onChangeBackgroundsTagValue,
  onChangeImagesTagValue,
  onClickBackgroundTag,
  onClickDeleteBackgroundFormat,
  onclickDeleteBackgroundTag,
  onclickDeleteImageTag,
  onClickImageTag,
  onclickSaveFormatsBackground,
  onclickSaveTagsBackground,
  onclickSaveTagsImage,
  onClickPhotoInfo,
  onShadowChangeColor,
  updateObjectShadow,
  onShadowRemove,
} from '~src/sidebar/index';
import {
  handleQrForm,
  setDefaultQrCodeValues,
  handleQrTypeSelection,
} from '~src/sidebar/qr';
import { eraserPreviewSlider, undoEraser } from './sidebar/eraserPreview';
import { onErrorShowMessage } from '~src/errors';
import { isLoggedUserGlobalEditor, getUser } from '~src/user';
import {
  fetchEditorBackgroundsNextPage,
  handleEditorBackgroundsScroll,
} from './sidebar/infiniteScrolling/handleEditorBackgroundsScroll';
import { initContextMenuListeners } from '~src/utils/contextMenu';
import {
  createTemplatesCategory,
  createNewTemplateClickHandler,
  duplicateTemplateClickHandler,
  deleteTemplateClickHandler,
  renameTemplateClickHandler,
} from '~loader/loader-event-handlers';
import { onTemplateImportSettingsClick } from '~core/templateImportSettings';
import { requestNewTemplate, requestNewEvent } from '~src/userRequest';
import {
  createUploaderInstance,
  onCompleteAttachment,
  onErrorAttachment,
} from '~uploader';
import {
  onChangeQuotesCategoryValue,
  handleTabQuotes,
  addHtmlInputQuote,
  handleDeleteQuoteBtn,
  cleanHtmlQuote,
  handleSaveQuoteBtn,
  filterQuotes,
} from './sidebar/quotes';
import { stopMagicEraser } from '~core/magicEraser';
import { stopChangeClothes } from '~core/changeClothes';
import { handleCreateBackgroundWithAi } from '~core/aiBackground';
import { fetchAllegati } from '~graphql/controllers/allegati';
import { fetchEditorSymbolsDefault } from '~graphql/controllers/fetchEditorSymbolsDefault';

async function addPageBtnHandler(event) {
  event.preventDefault();
  await addPage(false);
}

const hideAllSidebarTabs = () => {
  $('.sidebar-tabs .tab').removeClass('active');
};

export function removeBackground() {
  window.canvas.backgroundColor = '#ffffff';
  window.canvas.backgroundImage = null;

  unsetState('backgroundVideoId');

  // Remove previous SVG background
  const previousBackgrounds = window.canvas
    .getObjects()
    .filter((object) => object.giotto?.isBackground);

  if (previousBackgrounds && previousBackgrounds.length > 0) {
    for (const previousBackground of previousBackgrounds) {
      if (previousBackground.getObjects) {
        previousBackground
          .getObjects()
          .forEach((obj) => window.canvas.remove(obj));
        window.canvas.remove(previousBackground);
      } else {
        window.canvas.remove(previousBackground);
      }
    }
    window.canvas.discardActiveObject().renderAll();
    window.canvas.renderAll();
  }

  window.canvas.renderAll.bind(window.canvas)();
  triggerStateChangedRequest();
}

function handleDeletebackgroundsBtn(event) {
  event.preventDefault();
  const editorBackgroundsId = $(event.currentTarget).data(
    'delete-backgrounds-id'
  );

  Swal.fire({
    title: 'Sei sicuro?',
    text: 'Vuoi cancellare lo sfondo?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#278e8e',
    cancelButtonColor: '#d33',
    cancelButtonText: 'No',
    confirmButtonText: 'Si, elimina',
  }).then(async (result) => {
    if (result.value) {
      Swal.fire({
        text: 'Sto eliminando lo sfondo...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await deleteBackgrounds(editorBackgroundsId);
        Swal.hideLoading();
        Swal.fire({
          title: 'Fatto!',
          html: 'Lo sfondo &egrave; stato eliminato.',
          icon: 'success',
          confirmButtonColor: '#278e8e',
        });
      } catch (error) {
        console.error(error);
        onErrorShowMessage();
      }
    }
  });
}

function handleDeleteImagesBtn(event) {
  event.preventDefault();
  const editorImagesId = $(event.currentTarget).data('delete-images-id');
  const isGlobal = $(event.currentTarget).data('delete-images-is-global');

  Swal.fire({
    title: 'Sei sicuro?',
    text: "Vuoi cancellare l'immagine?",
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#278e8e',
    cancelButtonColor: '#d33',
    cancelButtonText: 'No',
    confirmButtonText: 'Si, elimina',
  }).then(async (result) => {
    if (result.value) {
      Swal.fire({
        text: "Sto eliminando l'immagine...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await deleteImages(editorImagesId, isGlobal);
        Swal.hideLoading();
        Swal.fire({
          title: 'Rimossa!',
          html: "L'immagine &egrave; stata rimossa.",
          icon: 'success',
          confirmButtonColor: '#278e8e',
        });
      } catch (error) {
        Swal.hideLoading();
        console.error(error);
        onErrorShowMessage(false, {
          text: "Non è stato possibile eliminare l'immagine.",
        });
      }
    }
  });
}

function addInputQuotesEntry(event) {
  event.preventDefault();
  addHtmlInputQuote();
}

async function openPdfQuotes(event) {
  const { user } = await getUser();
  const category = getState('sidebarCurrentQuotesCategory');
  event.preventDefault();
  window.open(
    `${process.env.ETERNO_URL}/base_pdf/testi.php?id=${user.org_pointer.objectId}&categoryName=${category}`,
    '_blank'
  );
}

function removeCanvasBackgroundBtnHandler(event) {
  event.preventDefault();
  removeBackground();
}

const handleFilterFonts = (event) => {
  const filter = $(event.currentTarget).val().toLowerCase();
  const items = $('[data-search-font-family]');
  items.each((index) => {
    const fontFamily = $(items[index]).data('search-font-family');

    if (fontFamily.startsWith(filter)) {
      $(items[index]).show();
    } else {
      $(items[index]).hide();
    }
  });
};

const handleFilterQuotes = (event) => {
  const filter = $(event.currentTarget).val().toLowerCase();
  filterQuotes(filter);
};

function handleBackBtn(e) {
  e.preventDefault();
  returnToMenu();
}

function toggleEditorSidebar() {
  const isMagicEraserActive = getState('isMagicEraserActive');
  if (isMagicEraserActive) {
    return;
  }
  const isChangeClothesActive = getState('isChangeClothesActive');
  if (isChangeClothesActive) {
    return;
  }
  const isExpandActive = getState('isExpandActive');
  if (isExpandActive) {
    return;
  }
  const preventSidebarToggle = getState('preventSidebarToggle');
  if (preventSidebarToggle) {
    setTimeout(() => {
      modifyState('preventSidebarToggle', false);
    }, 500);
    return;
  }

  toggleState('isSidebarOpen');

  $('#editor-menu').toggleClass('sidebar-open');
  $('#sidebar-content').toggleClass('sidebar-open');
  $('#canvas-container').toggleClass('sidebar-open');
  $('.layout-editor-container').toggleClass('sidebar-opened');
  $('#editor-sidebar').toggleClass('sidebar-open');

  $('[data-navbar-submenu="text-opacity"]')
    .removeClass('active')
    .css('top', -1200);

  if (!getState('isSidebarOpen')) {
    unsetState('currentSidebarTab');
  } else {
    const activeTabId = $('.tab.active').attr('id');
    if (activeTabId) {
      const tabName = activeTabId.replace('tab-', '');
      modifyState('currentSidebarTab', tabName);
    }
  }
}

function showSidebarTab(tabName) {
  if (!getState('isSidebarOpen')) {
    toggleEditorSidebar();
  }
  hideAllSidebarTabs();
  $('[data-tab-target]').removeClass('active');
  $(`#tab-${tabName}`).addClass('active');
  modifyState('currentSidebarTab', tabName);
}

function closeManipulationCanvases() {
  const isMagicEraserActive = getState('isMagicEraserActive');
  if (isMagicEraserActive) {
    stopMagicEraser();
  }
  const isChangeClothesActive = getState('isChangeClothesActive');
  if (isChangeClothesActive) {
    stopChangeClothes();
  }
}

const sidebarBtnHandler = (event) => {
  // Open actual tab
  const isSidebarOpen = getState('isSidebarOpen');
  const tabTargetId = $(event.currentTarget).data('tab-target');
  const activeSidebarBtns = $('.btn-sidebar.active');

  $('.btn-sidebar').removeClass('active');
  $(event.currentTarget).addClass('active');
  $('#sidebar-content .tab').removeClass('active');
  $(`#${tabTargetId}`).addClass('active');

  closeManipulationCanvases();

  // I toggle the sidebar if the sidebar is closed
  if (!isSidebarOpen) {
    toggleEditorSidebar();
    return;
  }

  // I toggle the sidebar if the selected button is the same that is already open
  const currentTarget = $(activeSidebarBtns[0]).data('tab-target');
  if (tabTargetId === currentTarget) {
    toggleEditorSidebar();
    return;
  }
};

function addSidebarBtnListeners() {
  $('#qr-website').addClass('qr-active');

  $('body').on('submit', '#qr-form', handleQrForm);
  $('body').on('click', '#qr-form-submit', handleQrForm);
  $('body').on('click', '.qr-selection', handleQrTypeSelection);
  $('body').on('click', '[data-tab-target]', sidebarBtnHandler);
  $('body').on(
    'click',
    '[data-save-tag-background-id]',
    onclickSaveTagsBackground
  );
  $('body').on(
    'click',
    '[data-save-format-background-id]',
    onclickSaveFormatsBackground
  );

  $('#input-filter-quotes').on('search', () => {
    const items = $('[data-text]');
    items.show();
  });
  $('#input-filter-fonts').on('search', () => {
    const items = $('[data-search-font-family]');
    items.show();
  });

  $('body').on('click', '[data-save-tag-image-id]', onclickSaveTagsImage);
  $('body').on('click', '[data-delete-tag-id]', onclickDeleteImageTag);
  $('body').on(
    'click',
    '[data-delete-background-tag-id]',
    onclickDeleteBackgroundTag
  );
  $('body').on(
    'click',
    '[data-delete-background-format-id]',
    onClickDeleteBackgroundFormat
  );
  $('body').on(
    'click',
    '[data-tab-target="tab-manage-business-logo"]',
    handleSidebarLogos
  );
  $('#sidebar-close').click(toggleEditorSidebar);

  // Filters Sliders
  $('input[type="range"][data-filter]').change(onFilterValueChange);
  $('input[type="range"][data-filter]').on('input', onFilterValueChange);

  // Filters TextBoxes
  $('input[type="number"][data-filter]').change(onFilterTextValueChange);

  // Font Spacing Vertical
  $('#editor-text-spacing-v-slider').change(onTextSpacingValueChangeV);
  $('#editor-text-spacing-v-value').change(onTextSpacingValueChangeV);
  $('#editor-text-spacing-v-slider').on('input', onTextSpacingValueChangeV);

  // Font Spacing Horizontal
  $('#editor-text-spacing-h-slider').change(onTextSpacingValueChangeH);
  $('#editor-text-spacing-h-value').change(onTextSpacingValueChangeH);
  $('#editor-text-spacing-h-slider').on('input', onTextSpacingValueChangeH);

  $('#editor-text-opacity-slider').on('input', onTextOpacityValueChange);
  $('#editor-text-opacity-slider').on('change', onTextOpacityValueChange);

  $('body').on('click', '#editor-menu-add-page', addPageBtnHandler);
  $('#editor-menu-add-quote').click(addInputQuotesEntry);
  $('#editor-menu-open-pdf-quote').click(openPdfQuotes);
  $('#editor-menu-remove-canvas-background').click(
    removeCanvasBackgroundBtnHandler
  );
  const onShadowPropertyUpdate = (event) => {
    event.preventDefault();
    updateObjectShadow();
  };

  $('body').on('click', '#editor-menu-remove-shadow', onShadowRemove);
  $('body').on('click', '#editor-menu-shadow-color', onShadowChangeColor);
  $('body').on(
    'input',
    '#editor-object-offset-v-slider',
    onShadowPropertyUpdate
  );
  $('body').on(
    'input',
    '#editor-object-offset-h-slider',
    onShadowPropertyUpdate
  );
  $('body').on('input', '#editor-object-blur-slider', onShadowPropertyUpdate);
  $('body').on(
    'input',
    '#editor-object-opacity-slider',
    onShadowPropertyUpdate
  );
  $('body').on('input', '#editor-object-eraser-slider', eraserPreviewSlider);
  $('body').on('click', '#editor-menu-undo-eraser', undoEraser);
  $('body').on('click', '#editor-menu-stop-eraser', () => {
    toggleObjectEraser();
    showSidebarTab('edit-images-tools');
  });
  $('body').on('click', '#editor-menu-abort-eraser', () => {
    toggleObjectEraser();
    showSidebarTab('edit-images-tools');
  });
}

const fetchEditorAttachments = async () => {
  const servizio = getState('selected.servizio', {});
  let where = {};
  if (servizio && servizio.objectId) {
    where.defunto_pointer = {
      have: { objectId: { equalTo: servizio.objectId } },
    };
  } else {
    where.editor_canvas_pointer = {
      have: { objectId: { equalTo: window.editorLoader.canvasId } },
    };
  }
  const allegati = await fetchAllegati(where, ['createdAt_DESC'], 1000);
  const onlyImages = allegati.filter((item) => {
    if (!item.allegato) return false;
    const ext = getUrlExtension(item.allegato.url);
    return editorConfig.attachmentsAllowedFileExtensions.includes(ext);
  });
  return {
    attachments: {
      items: onlyImages,
    },
  };
};

const fetchEditorFrames = async () => {
  const httpClient = await getAxiosClient();
  return new Promise((resolve, reject) => {
    const hasCache = _.has(window.editorConfig, 'sidebarFrames.items');

    if (hasCache) {
      return resolve({
        attachments: {
          allowNew: false,
          items: window.editorConfig.sidebarFrames,
        },
      });
    }

    httpClient
      .get(`${process.env.PARSE_API_URL}/editor_frames`)
      .then((response) => {
        const items = response.data.data.reduce((acc, item) => {
          acc.push({
            id: item.objectId,
            url: item.file.url,
          });

          return acc;
        }, []);

        resolve({
          frames: {
            allowNew: false,
            items,
          },
        });
      })
      .catch((error) => {
        console.error(error);
        // TODO: Gestire errore (400, 403, 404, 500, etc)
        reject(error);
      });
  });
};

const onAttachmentClick = (event) => {
  const isBackgroundFusion =
    $(event.currentTarget).data('background-fusion') === true;

  if (isBackgroundFusion) {
    return onBackgroundChange(event);
  }

  return onAddImageToCanvas(event);
};

function displaySidebarAttachments() {
  const { ids, html } = window.editorConfig.sidebarAttachments.items.reduce(
    (acc, item) => {
      if (!_.has(item, 'allegato.url')) {
        return acc;
      }
      const previewImg = new EdgeResizer(item.allegato.url).scaleToWidth(160);
      const servizio = getState('selected.servizio');
      const extensionUrl = getUrlExtension(item.allegato.url);
      const isBackgroundFusion = item.isBackgroundFusion === true;

      let isPhotoProfile = false;
      let attachmentType = 'default';
      if (
        servizio &&
        _.has(servizio, 'allegati_pointer.objectId', false) &&
        servizio.allegati_pointer.objectId === item.objectId
      ) {
        isPhotoProfile = true;
        attachmentType = 'profilePhoto';
      }
      const itemId = `editor-sidebar-add-canvas-attachment-${item.objectId}`;
      let buttons = `<div class="option-button-container bg-color-attachments">
              <div class="option-button-container-relative">
              <div class="context-menu context-menu-child bg-color-attachments color-existing-canvas">
              `;

      if (servizio && !isPhotoProfile && !isBackgroundFusion) {
        buttons += `
        <div
          class="item context-menu-child"
          data-attachment-profile-item-id="${item.objectId}"
          data-attachment-defunto-id="${servizio?.objectId}">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Imposta come foto profilo
        </div>`;
      }
      buttons += `
              <div class="item context-menu-child" data-download-attachment="${item.allegato.url}">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path fill="none" d="M9.634,10.633c0.116,0.113,0.265,0.168,0.414,0.168c0.153,0,0.308-0.06,0.422-0.177l4.015-4.111c0.229-0.235,0.225-0.608-0.009-0.836c-0.232-0.229-0.606-0.222-0.836,0.009l-3.604,3.689L6.35,5.772C6.115,5.543,5.744,5.55,5.514,5.781C5.285,6.015,5.29,6.39,5.522,6.617L9.634,10.633z"></path>
                  <path fill="none" d="M17.737,9.815c-0.327,0-0.592,0.265-0.592,0.591v2.903H2.855v-2.903c0-0.327-0.264-0.591-0.591-0.591c-0.327,0-0.591,0.265-0.591,0.591V13.9c0,0.328,0.264,0.592,0.591,0.592h15.473c0.327,0,0.591-0.264,0.591-0.592v-3.494C18.328,10.08,18.064,9.815,17.737,9.815z"></path>
                </svg>
                Scarica
              </div>`;
      buttons += `
              <div class="item context-menu-child" data-delete-attachment-id="${item.objectId}" data-attachment-type="${attachmentType}">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Elimina
              </div>
          </div>
        </div>
      </div>`;
      buttons += `<div
                        id="editor-sidebar-sub-menu-${item.objectId}"
                      class="editor-sidebar-item-image-sub-menu-container">
                      <button
                        class="btn editor-img-tag-alone"
                        data-photo-item-id="${item.objectId}"
                        data-tab-target="tab-photo-info">
                        INFO
                      </button>
                    </div>`;

      acc.html += `
        <div
          data-url="${item.allegato.url}"
          data-background-fusion="${isBackgroundFusion}"
          data-force-background="${isBackgroundFusion}"
          data-sidebar-type="allegato"
          id="editor-sidebar-add-canvas-attachment-${item.objectId}"
          class="sidebar-item-grid-box image-square-container box-attachment">`;

      if (isPhotoProfile) {
        acc.html += `      
        <div
          class="sidebar-badge-profile-photo rounded-circle"
          data-toggle="tooltip"
          data-placement="bottom"
          title="Attuale Foto Profilo">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" width="30" height="30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>`;
      }
      if (isBackgroundFusion) {
        acc.html += `
        <div
          class="sidebar-badge-background-fusion"
          data-toggle="tooltip"
          data-placement="bottom"
          title="Questo allegato verrà applicato come sfondo">
          Sfondo
        </div>`;
      }
      acc.html += `
                    <img
                    src="../assets/svg/img-loader.gif"
                        class="lazy image-square"
                        data-src="${previewImg}"
                    />
                    ${buttons}
                </div>`;

      acc.ids.push(`#${itemId}`);
      if (
        !editorConfig.attachmentsAllowedFileExtensions.includes(extensionUrl)
      ) {
        return acc;
      }
      return acc;
    },
    { ids: [], html: '' }
  );

  if (ids.length) {
    $('body').off('click', 'div[data-sidebar-type="allegato"]');
    $('body').on(
      'click',
      'div[data-sidebar-type="allegato"]',
      onAttachmentClick
    );
  }

  $('.items-container-attachments-grid').html(html);
  window.lazyLoadInstance.update();
  enableTooltips();
}

function displaySidebarSymbols() {
  const { ids, html } = window.editorConfig.sidebarSymbols.items.reduce(
    (acc, item) => {
      const itemId = `editor-sidebar-add-canvas-symbol-${item.id}`;

      acc.html += `<div
                  id="${itemId}"
                  data-url="${item.url}"
                  class="sidebar-item-grid-box image-square-container">
                    <img
                        src="../assets/svg/img-loader.gif"
                        class="lazy image-square"
                        data-src="${item.url}"
                    />
                </div>`;

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  $('body').on('click', ids.join(','), onAddImageToCanvas);
  $('#tab-simboli .items-container-grid').html(html);
  window.lazyLoadInstance.update();
}

function displaySidebarFrames() {
  const html = window.editorConfig.sidebarFrames.items.reduce((acc, item) => {
    acc += `<div
                  class="sidebar-item-grid-box image-square-container ">
                    <img
                        src="../assets/svg/img-loader.gif"
                        class="lazy image-square sidebar-frames"
                        data-src="${item.url}"
                        data-url="${item.url}"
                    />
                </div>`;
    return acc;
  }, '');

  $('#tab-cornici .items-container-grid').html(html);
  window.lazyLoadInstance.update();
}

function handleTabBackgrounds() {
  modifyState('currentSidebarTab', 'manifesti');
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');
  const hasItems = _.has(
    window.editorConfig,
    `sidebarBackgrounds[${currentTag}].items`
  );

  if (hasItems === false) {
    handleSidebarBackgrounds();
  }
}

function handleTabAttachments() {
  modifyState('currentSidebarTab', 'allegati');
  if (
    !window.editorConfig.sidebarAttachments ||
    !window.editorConfig.sidebarAttachments.items
  ) {
    fetchEditorAttachments().then((response) => {
      window.editorConfig.sidebarAttachments = response.attachments;
      displaySidebarAttachments();
    });
  }
}

function handleTabSymbols() {
  modifyState('currentSidebarTab', 'simboli');
  if (
    !window.editorConfig.sidebarSymbols ||
    !window.editorConfig.sidebarSymbols.items
  ) {
    fetchEditorSymbolsDefault()
      .then((response) => {
        window.editorConfig.sidebarSymbols = response.symbols;
        displaySidebarSymbols();
      })
      .catch((error) => {
        console.error(error);
        onErrorShowMessage();
      });
  }
}

function handleTabImages() {
  modifyState('currentSidebarTab', 'immagini');
  if (
    !window.editorConfig.sidebarImages ||
    !window.editorConfig.sidebarImages.items
  ) {
    return handleSidebarImages();
  }
}

/**
 * Initialize organization exception check for AI Credits Info Modal
 */
function initAiCreditsInfoModalOrgCheck() {
  $('#aiCreditsInfoModal').on('shown.bs.modal', async function () {
    try {
      const userData = await getUser();

      if (
        userData &&
        userData.user &&
        userData.user.org_pointer &&
        userData.user.org_pointer.createdAt
      ) {
        const orgCreatedAt = new Date(userData.user.org_pointer.createdAt);
        const exceptionCutoffDate = new Date('2025-04-01');

        if (orgCreatedAt < exceptionCutoffDate) {
          $('#orgExceptionAlert').show();
        }
      }
    } catch (error) {
      console.error('Error checking organization exception:', error);
    }
  });
}

function handleTabFrames() {
  modifyState('currentSidebarTab', 'cornici');
  if (
    !window.editorConfig.sidebarFrames ||
    !window.editorConfig.sidebarFrames.items
  ) {
    fetchEditorFrames().then((response) => {
      window.editorConfig.sidebarFrames = response.frames;
      displaySidebarFrames();
    });
  }
}

function flipXToogle(event) {
  event.preventDefault();
  let activeImage = getState('activeObject');
  if (activeImage.type === 'MagicFrame') {
    activeImage = activeImage.editingImg;
  }
  if (activeImage.flipX) {
    activeImage.set({
      flipX: false,
    });
  } else {
    activeImage.set({
      flipX: true,
    });
  }
  window.canvas.renderAll();
  triggerStateChangedRequest();
}
function flipYToogle(event) {
  event.preventDefault();
  let activeImage = getState('activeObject');
  if (activeImage.type === 'MagicFrame') {
    activeImage = activeImage.editingImg;
  }
  if (activeImage.flipY) {
    activeImage.set({
      flipY: false,
    });
  } else {
    activeImage.set({
      flipY: true,
    });
  }
  window.canvas.renderAll();
  triggerStateChangedRequest();
}

function editQuotesToggle(event) {
  event.preventDefault();
  cleanHtmlQuote();
  $('#editor-sidebar-quotes').toggleClass('editor-sidebar-pages-editable');
}

function hideNavButtons(event) {
  event.preventDefault();
  if ($(window).width() < 1000) {
    if (getState('isSidebarOpen')) {
      $('.btn-hide-on-small-device').show();
    } else {
      $('.btn-hide-on-small-device').hide();
    }
  }
  if ($(window).width() < 900) {
    if (getState('isSidebarOpen')) {
      $('#editor-submenu-rigth').show();
      $('#editor-submenu-left').show();
    } else {
      $('#editor-submenu-rigth').hide();
      $('#editor-submenu-left').hide();
    }
  }
}

function editPagesToogle(event) {
  event.preventDefault();
  $('#editor-sidebar-pages').toggleClass('editor-sidebar-pages-editable');
}

const handleSidebarInnerTabToggle = (event) => {
  const innerTabTargetName = $(event.currentTarget).data(
    'sidebar-tab-target-name'
  );

  modifyState('activeSidebarSubTab', innerTabTargetName);

  const innerTabTargetNameSpace = $(event.currentTarget).data(
    'sidebar-tab-target-namespace'
  );

  // Disabilita tutti i bottoni
  $(`[data-sidebar-tab-target-namespace="${innerTabTargetNameSpace}"]`)
    .removeClass('buttonSidebarTabActive')
    .addClass('buttonSidebarTabDisable');

  // Abilita il bottone cliccato
  $(`[data-sidebar-tab-target-name="${innerTabTargetName}"]`).addClass(
    'buttonSidebarTabActive'
  );

  // Disabilita tutti i box
  $(`[data-sidebar-tab-namespace="${innerTabTargetNameSpace}"]`)
    .removeClass('active')
    .addClass('inactive');

  // Abilita il box selezionato
  $(`[data-sidebar-tab-name="${innerTabTargetName}"]`)
    .addClass('active')
    .removeClass('inactive');
};

function hideSidebarTab(tabName) {
  if (!getState('isSidebarOpen')) {
    toggleEditorSidebar();
  }
  // $(`#sidebar-content`).addClass('sidebar-open');
  $(`#tab-${tabName}`).removeClass('active');
  // $(`#tab-${tabName}`).addClass('active');
}

function scrollToBottomOfCurrentTab() {
  const scrollTo = $('.scroll-to-bottom').position().top;

  if (!scrollTo) {
    return;
  }

  $('#sidebar-content').animate(
    { scrollTop: $('.scroll-to-bottom').position().top },
    800,
    'swing'
  );
}

async function initSidebar() {
  const { user } = await getUser();
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const templatesCategory = getState('selected.templatesCategory');

  modifyState('isSidebarOpen', false);

  $('body').on(
    'click',
    '[data-tab-target="tab-edit-images-ai"]',
    handleTabImagesAI
  );

  if (!user.org_pointer?.stripe_customer_id) {
    $('[data-sidebar-action="buy-ai-credits"]').remove();
  }

  $('body').on('click', '[data-sidebar-action="buy-ai-credits"]', async () => {
    await handleBuyAiCredits();
  });

  $('#btn-sidebar-backgrounds').click(handleTabBackgrounds);
  $('.editor-sidebar-show-allegati-btn').click(handleTabAttachments);
  $('#btn-sidebar-symbols').click(handleTabSymbols);
  $('#btn-sidebar-images').click(handleTabImages);
  $('#btn-menu-frames').click(handleTabFrames);
  $('#editor-sidebar-flip-h').click(flipXToogle);
  $('#editor-sidebar-flip-v').click(flipYToogle);
  $('#editor-back-menu').click(handleBackBtn);
  $('#btn-sidebar-quotes').click(handleTabQuotes);

  if (templatesCategory && templatesCategory.annunciFunebri) {
    $('#btn-sidebar-annuncio-funebre').removeClass('d-none');
    $('#btn-sidebar-annuncio-funebre').click(handleTabAnnunciFunebri);
  }
  $('#btn-sidebar-templates').click(handleTabTemplates);
  $('#editor-menu-editable-quote').click(editQuotesToggle);
  $('body').on('click', '#editor-menu-editable-page', editPagesToogle);
  $('body').on('click', '.btn-sidebar', hideNavButtons);
  $('body').on('click', '.btn-sidebar-pages-delete', handleDeletePageBtn);
  $('body').on('click', '.btn-sidebar-quotes-delete', handleDeleteQuoteBtn);
  $('body').on('click', '[data-delete-images-id]', handleDeleteImagesBtn);
  $('body').on('click', '[data-delete-attachment-id]', handleDeleteAttachment);
  $('body').on('click', '[data-download-attachment]', handleDownloadAttachment);
  $('body').on(
    'click',
    '[data-attachment-profile-item-id]',
    handleSetPhotoProfile
  );
  $('body').on(
    'click',
    '[data-delete-backgrounds-id]',
    handleDeletebackgroundsBtn
  );
  $('body').on('click', '#button-clean-html-quotes', cleanHtmlQuote);
  $('body').on('click', '#button-save-quote', handleSaveQuoteBtn);
  $('body').on('click', '[data-page-index]', handleChangePageBtn);
  // $('body').on('click', '.sidebar-frames', handleFrameClick);

  // Search inputs
  $('#input-filter-fonts').keyup(handleFilterFonts);
  $('#input-filter-quotes').keyup(handleFilterQuotes);

  // Images & Tags
  listenForImagesTagSearchEmpty();
  $('body').on(
    'click',
    '#uploadBackgroundsMultiTag',
    displayBackgroundManagerMultiTag
  );
  $('body').on(
    'click',
    '#createBackgroundWithAi',
    handleCreateBackgroundWithAi
  );
  $('body').on('click', '#uploadImagesMultiTag', displayImageManagerMultiTag);
  $('body').on('click', '[data-backgrounds-item-id]', onClickBackgroundTag);
  $('body').on('click', '[data-images-item-id]', onClickImageTag);
  $('body').off('select2:select', '#select-ricerca-immagini');

  $('body').on(
    'click',
    '[data-sidebar-tab-target-name]',
    handleSidebarInnerTabToggle
  );
  $('body').off('select2:select', '#select-ricerca-immagini');

  $('body').on(
    'select2:select',
    '#select-ricerca-immagini',
    onChangeImagesTagValue
  );
  $('#select-ricerca-immagini').on(
    'select2:unselecting',
    onChangeImagesTagValue
  );
  $('#select-ricerca-backgrounds').on(
    'select2:unselecting',
    onChangeBackgroundsTagValue
  );
  $('body').off('select2:select', '#select-ricerca-backgrounds');
  $('body').on(
    'select2:select',
    '#select-ricerca-backgrounds',
    onChangeBackgroundsTagValue
  );
  $('body').off('select2:select', '#select-categories-quotes');
  $('body').on(
    'select2:select',
    '#select-categories-quotes',
    onChangeQuotesCategoryValue
  );

  $('body').on(
    'click',
    '#fetchMoreBackgrounds',
    fetchEditorBackgroundsNextPage
  );

  addSidebarBtnListeners();
  handleEditorBackgroundsScroll();

  const opensidebar =
    getState('opensidebar') || window.urlParams.get('opensidebar');

  if (opensidebar) {
    const preOpenSidebarBtn = $(`[data-tab-target="tab-${opensidebar}"]`);
    $(preOpenSidebarBtn).trigger('click');
    unsetState('opensidebar');
  }

  $('body').off('click', '[data-photo-item-id]');
  $('body').on('click', '[data-photo-item-id]', (event) => {
    onClickPhotoInfo(event);
    event.stopPropagation();
  });
  initContextMenuListeners();
  $('body').on(
    'click',
    '[data-giotto-duplicate-template]',
    duplicateTemplateClickHandler
  );
  $('body').on(
    'click',
    '[data-giotto-rename-template]',
    renameTemplateClickHandler
  );
  $('body').on(
    'click',
    '[data-giotto-delete-template]',
    deleteTemplateClickHandler
  );
  $('body').on(
    'click',
    '[data-giotto-template-import-settings]',
    onTemplateImportSettingsClick
  );
  $('body').on(
    'click',
    '[data-giotto-create-template]',
    createNewTemplateClickHandler
  );
  $('body').on(
    'click',
    '[data-giotto-create-template-category]',
    createTemplatesCategory
  );
  $('body').on(
    'click',
    '[data-giotto-request-new-template]',
    requestNewTemplate
  );

  // Initialize AI Credits Info Modal org exception check
  initAiCreditsInfoModalOrgCheck();
  $('body').on(
    'click',
    '[data-giotto-request-template-category]',
    requestNewEvent
  );

  await setDefaultQrCodeValues('Sito Web');

  if (isGlobalEditor) {
    $('#btn-sidebar-attachments').remove();
    $('#btn-sidebar-annuncio-funebre').remove();
  } else {
    // Init Uploader - Allegati
    createUploaderInstance({
      alias: 'allegati',
      bucket: 'default',
      onComplete: onCompleteAttachment,
      onError: onErrorAttachment,
      pluginDashboard: {
        trigger: '#editor-sidebar-upload-btn',
        target: 'body',
      },
    });
    // Ephemeral uploader to be used for temporary images that need an URL but don't need to be attached
    createUploaderInstance({
      alias: 'ephemeral',
      bucket: 'default',
    });
  }
}

export {
  initSidebar,
  toggleEditorSidebar,
  handleDeleteImagesBtn,
  handleDeletebackgroundsBtn,
  showSidebarTab,
  hideSidebarTab,
  handleTabAttachments,
  scrollToBottomOfCurrentTab,
  fetchEditorAttachments,
  displaySidebarAttachments,
  handleTabImages,
  hideAllSidebarTabs,
};
